import { CategoryType } from '@habity/types';

export const getStaticMapMarkerUrl = (category: CategoryType) => {
  return `/map/markers/${category}.png`;
};

export const getStaticMapProjectMarkerUrl = () => {
  return `/map/markers/project.png`;
};

